export const Revision = 6042;